import React from "react"

function Footer() {
    return(
        <section id="footer">
            <div className="d-flex flex-column col-9 mx-auto py-3">
                <p className="mb-0 text-center">&copy; Lista S, 2020</p>
            </div>
        </section>
    )
}

export default Footer